module.exports = __webpack_public_path__ + "images/businesslease_smallee0397fd2271d01fe9d8f39772660f4b.png";